import { changeItem, addToCart } from './cart.js?v=30';

class MainCart extends HTMLElement {
  constructor() {
    super();
    this.containsPreorderProduct = false;
    this.controller = new AbortController();
    this.checkoutButton = null;
    this.giftWrappingProduct = null;
    this.addGiftWrapping = false;
    this.addGiftWrappingCheckbox = null;
    this.giftMessageTextarea = null;
    this.giftWrappingExists = false;
    this.giftWrappingKey = null;
    this.errorMessage = null;
    this.buttonTextCheckout = null;
    this.buttonLoadingText = null;
    this.isCheckingOut = false;
    this.termsLabel = null;
    this.checkoutSignInButton = null;
    this.checkoutRegisterButton = null;
    this.itemNotAvailableMessage = null;
    this.itemNotAvailableMessagePlural = null;
    this.itemNotAvailableMessageSingular = null;
  }

  connectedCallback() {
    const signal = this.controller.signal;

    this.termsLabel = document.querySelector('[data-terms-label]')
    this.checkoutSignInButton = this.querySelector('[data-checkout-sign-in-button]');
    this.checkoutRegisterButton = this.querySelector('[data-checkout-register-button]');
    this.itemNotAvailableMessage = this.getAttribute('data-item-not-available-message');
    this.itemNotAvailableMessagePlural = this.getAttribute('data-item-not-available-message-plural');
    this.itemNotAvailableMessageSingular = this.getAttribute('data-item-not-available-message-singular');
    this.buttonTextCheckout = this.getAttribute('data-button-text-checkout');
    this.buttonLoadingText = this.getAttribute('data-button-loading-text');
    this.errorMessage = document.querySelector(
      '[data-main-shopping-cart-error]'
    );
    this.giftWrappingKey = this.getAttribute('data-gift-wrapping-key');
    this.giftWrappingExists =
      this.getAttribute('data-gift-wrapping-exists') === 'true';
    this.giftMessageTextarea = document.querySelector(
      '[data-gift-message-textarea]'
    );
    this.addGiftWrappingCheckbox = document.querySelector(
      '[data-add-gift-wrapping-checkbox]'
    );
    this.giftWrappingProduct = this.getAttribute('data-gift-wrapping-product');
    this.containsPreorderProduct =
      this.getAttribute('data-contains-preorder-product') === 'true';
    this.termsCheckbox = this.querySelector('[data-terms-checkbox]');
    this.checkoutButton = this.querySelector('[data-checkout-button]');

    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', () => this.checkout(), {
        signal,
      });
    }

    if (this.checkoutSignInButton) {
      this.checkoutSignInButton.addEventListener('click', () => this.checkoutSignIn(), {
        signal,
      });
    }

    if (this.checkoutRegisterButton) {
      this.checkoutRegisterButton.addEventListener('click', () => this.checkoutRegister(), {
        signal,
      });
    }

    if (this.termsCheckbox && this.checkoutButton) {
      this.termsCheckbox.addEventListener(
        'change',
        () => {
          this.checkoutButton.disabled = !this.termsCheckbox.checked;
          if (this.checkoutSignInButton) this.checkoutSignInButton.disabled = !this.termsCheckbox.checked;
          if (this.checkoutRegisterButton) this.checkoutRegisterButton.disabled = !this.termsCheckbox.checked;
          sessionStorage.setItem('terms-and-conditions-checked', this.termsCheckbox.checked);
          if (this.termsLabel) {
            this.termsLabel.setAttribute('data-checked',this.termsCheckbox.checked)
          }
        },
        { signal }
      );
    }

    const giftTextarea = document.getElementById('gift_message');
    const giftCounter = document.getElementById('gift_message_count');

    if (giftTextarea && giftCounter) {
      giftTextarea.addEventListener(
        'input',
        () => {
          giftCounter.textContent = giftTextarea.value.length;
        },
        { signal }
      );
    }

    document.addEventListener(
      'cart:error',
      (e) => {
        if (this.checkoutButton) {
          this.checkoutButton.textContent = this.buttonTextCheckout;
          this.checkoutButton.disabled = false;
          this.isCheckingOut = false;
        }
        if (e.detail.itemKey) {
          const itemError = document.querySelectorAll(`[data-item-error="${e.detail.itemKey}"]`);
          itemError.forEach(item => {
            item.textContent = e.detail.message;
            item.classList.remove('opacity-0');
            setTimeout(() => {
              item.classList.add('opacity-0');
            }, 3000);
          });
        } else {
          if (this.errorMessage) {
            this.errorMessage.textContent = e.detail.message || e.detail;
            this.errorMessage.classList.remove('opacity-0');
            setTimeout(() => {
              this.errorMessage.classList.add('opacity-0');
            }, 3000);
          }
        }
      },
      { signal }
    );

    document.addEventListener(
      'preorder-popup:close',
      () => {
        if (this.checkoutButton) {
          this.checkoutButton.textContent = this.buttonTextCheckout;
          this.checkoutButton.disabled = true;
          this.isCheckingOut = false;
          if (this.termsCheckbox) {
            this.termsCheckbox.checked = false;
          }
        }
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  checkoutSignIn() {
    window.location.href = '/customer_authentication/login?return_to=/checkout';
  }

  checkoutRegister() {
    window.location.href = '/customer_authentication/login?return_to=/checkout';
  }

  async checkout() {
    if (this.isCheckingOut) return;
    this.isCheckingOut = true;

    this.checkoutButton.textContent = this.buttonLoadingText;
    this.checkoutButton.disabled = true;

    // even for a preorder, we can add gift wrapping
    if (this.giftWrappingProduct && this.giftWrappingProduct.length > 0) {
      const propertyGiftWrapping = (
        this.addGiftWrappingCheckbox?.checked ?? false
      ).toString();

      if (this.addGiftWrappingCheckbox) {
        if (this.giftWrappingExists) {
          const formData = {
            key: this.giftWrappingKey,
            quantity: this.addGiftWrappingCheckbox.checked ? 1 : 0,
            properties: {
              _isGiftWrapping: propertyGiftWrapping,
              Message: this.giftMessageTextarea?.value ?? '',
            },
          };
          await changeItem(formData, true, this.itemNotAvailableMessage, this.itemNotAvailableMessagePlural, this.itemNotAvailableMessageSingular);
        } else {
          const items = [
            {
              id: Number(this.giftWrappingProduct),
              quantity: propertyGiftWrapping === 'true' ? 1 : 0,
              properties: {
                _isGiftWrapping: propertyGiftWrapping,
                Message: this.giftMessageTextarea?.value ?? '',
              },
            },
          ];
          await addToCart(items, true);
        }
      }
    }
    if (this.containsPreorderProduct) {
      this.isCheckingOut = false;
      document.dispatchEvent(new CustomEvent('preorder-popup:open'));
      return;
    } else {
      window.location.href = '/checkout';
    }
  }
}

if (!customElements.get('main-cart')) {
  customElements.define('main-cart', MainCart);
}
